
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'customer-portal-app',
  currentProjectVersion: 'static-1.2691',
  depVersions: {
  "customer-portal-app": "static-1.2691",
  "apollo-dlb": "static-3.86",
  "client-types": "static-1.481",
  "data-fetching-client": "static-1.9780",
  "emoji-mart": "static-3.4",
  "enviro": "static-4.455",
  "growth-payments-core": "static-1.25729",
  "head-dlb": "static-1.5007",
  "hs-lodash": "static-4.45",
  "hs-promise-utils": "static-1.5711",
  "hs-test-utils": "static-1.8138",
  "hub-http": "static-1.6341",
  "hub-http-shared-msw-handlers": "static-1.10260",
  "hubspot-dlb": "static-2.1854",
  "hubspot-prosemirror": "static-1.18583",
  "hubspot-url-utils": "static-1.4132",
  "HubStyleTokens": "static-2.11590",
  "I18n": "static-7.1639",
  "immutable": "static-2.79",
  "jasmine-runner": "static-1.6576",
  "payment-link-components": "static-1.23831",
  "prosemirror": "static-1.13",
  "quartz": "static-1.7183",
  "quartz-core": "static-1.6402",
  "quartz-i18n": "static-1.858",
  "react": "static-7.187",
  "react-colorpicker": "static-2.10325",
  "react-dlb": "static-1.81",
  "react-utils": "static-2.5429",
  "rich-text-lib": "static-1.20043",
  "transmute": "static-2.85",
  "ui-addon-upgrades": "static-9.18157",
  "ui-components-test-utils": "static-1.5727",
  "UIComponents": "static-3.8536",
  "foundations-assets": "static-1.4991",
  "foundations-components": "static-1.8174",
  "foundations-theming": "static-1.4551",
  "foundations-theming-specialty": "static-1.2267",
  "framer-motion": "static-1.73",
  "metrics-js": "static-1.9637",
  "PortalIdParser": "static-2.404",
  "portals-platform-lib": "static-1.1175",
  "quartz-config": "static-1.961",
  "quartz-routing": "static-1.613",
  "quick-fetch": "static-1.4005",
  "react-dnd": "static-5.6",
  "react-dnd-html5-backend": "static-5.6",
  "react-dom": "static-7.85",
  "react-rhumb": "static-1.16802",
  "rpc-client-utils": "static-1.4775",
  "sanitize-text": "static-1.8263",
  "styled-components": "static-2.89",
  "tanstack-table": "static-1.56",
  "ui-addon-draggable": "static-3.4877",
  "ui-addon-react-router-dom": "static-1.9655",
  "usage-tracker": "static-1.7467",
  "usage-tracker-anonymous": "static-1.5884",
  "usage-tracker-core": "static-1.7317",
  "video-components-external": "static-1.11665",
  "apollo-stack-hubspot": "static-3.84",
  "hs-promise-rejection-tracking": "static-1.5587",
  "raven": "static-3.5925",
  "raven-hubspot": "static-1.6232",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "react-redux": "static-7.71",
  "redux": "static-4.16",
  "bend-plugin-trellis-migration": "static-1.3485",
  "moment": "static-3.26",
  "bend-plugin-quartz": "static-1.3460",
  "quartz-webpack": "static-1.3407",
  "bend-plugin-quartz-routing": "static-1.261",
  "fast-json-stable-stringify": "static-1.4",
  "graphql": "static-1.83",
  "customer-data-objects": "static-1.7797",
  "frontend-preferences-client": "static-1.8045",
  "laboratory-lib": "static-3.7271",
  "onboarding-scopes": "static-1.6578",
  "seat-types-lib": "static-1.280",
  "ui-addon-opt": "static-4.8479",
  "HeadJS": "static-2.771",
  "hs-test-utils-bend-plugin": "static-1.3249",
  "msw": "static-1.39",
  "testing-library": "static-1.153",
  "hs-locale-management": "static-1.169",
  "ts-schema": "static-1.4169",
  "webpack-env": "static-1.54",
  "content-assistance-lib": "static-1.7948",
  "content-media-capture": "static-1.4876",
  "cssUtils": "static-1.826",
  "customer-data-ui-utilities": "static-1.9943",
  "file-manager-components": "static-1.23960",
  "HubStyle": "static-2.11897",
  "knowledge-content-types": "static-1.8559",
  "PatternValidationJS": "static-1.437",
  "react-input-autosize": "static-2.17",
  "StyleGuideUI": "static-3.489",
  "ui-addon-emoji-picker": "static-1.10005",
  "ui-addon-i18n": "static-1.11267",
  "ui-business-units-lib": "static-1.9185",
  "ui-shepherd-react": "static-3.10369",
  "video-data-lib": "static-1.35323",
  "i18n-data": "static-1.223",
  "moment-timezone": "static-5.84",
  "jasmine": "static-4.4444",
  "commerce-tours-lib": "static-1.6323",
  "customer-data-properties": "static-1.51977",
  "getting-started-shared-tasks": "static-1.18744",
  "growth-onboarding-reliability": "static-1.5199",
  "onboarding-tours": "static-1.16831",
  "reference-resolvers-lite": "static-1.8215",
  "sales-checkout-service-client": "static-1.3711",
  "ui-addon-iframeable": "static-1.9185",
  "user-context": "static-1.5227",
  "dispatcher": "static-1.138",
  "general-store": "static-6.20",
  "hub-http-janus": "static-1.846",
  "hubspotter-http": "static-1.4738",
  "icons": "static-2.654",
  "mobile-manifest-mixins": "static-1.545",
  "module-federation": "static-1.27",
  "quartz-auth": "static-1.858",
  "quartz-head": "static-1.848",
  "quartz-test": "static-1.858",
  "quartz-tracking": "static-1.562",
  "trellis-components": "static-1.2217",
  "ui-fonts": "static-1.852",
  "usage-tracker-container": "static-1.7457",
  "csstype": "static-1.50",
  "hs-story-utils": "static-1.9541",
  "data-token-picker": "static-1.16625",
  "FileManagerLib": "static-1.39600",
  "property-translator": "static-1.5515",
  "atom": "static-1.5193",
  "merchandise-lib": "static-1.266",
  "purchase-motions-components": "static-1.6098",
  "salesImages": "static-1.527",
  "SharedI18nStrings": "static-1.182",
  "foundations-components-test-utils": "static-1.5657",
  "react-create-root-preference": "static-1.37",
  "react-select-plus": "static-1.106",
  "react-virtualized": "static-2.100",
  "ui-images": "static-2.1184",
  "bend-plugin-foundations-components": "static-1.4444",
  "floating-ui": "static-1.58",
  "react-aria": "static-1.67",
  "trellis-assets": "static-1.2198",
  "bend-plugin-foundations-theming": "static-1.3034",
  "foundations-theming-base": "static-1.3536",
  "stylex": "static-1.35",
  "interframe": "static-3.4878",
  "js-cookie": "static-1.18",
  "usage-tracker-multi": "static-1.5881",
  "web-vitals": "static-1.7",
  "bend-plugin-chirp-manifest": "static-1.185",
  "chirp-fetch": "static-1.2006",
  "autolinker": "static-3.11",
  "sanitize": "static-1.4594",
  "react-flip-move": "static-1.72",
  "apollo-link-hub-http": "static-2.4769",
  "content-media-composition-data-lib": "static-1.12680",
  "content-media-compositions": "static-2.16687",
  "idb-keyval": "static-1.45",
  "immer": "static-1.33",
  "immerable": "static-1.4268",
  "magpie-lib": "static-1.5629",
  "magpie-types": "static-1.5089",
  "media-bridge-lib": "static-1.19138",
  "bender-build-tools": "static-1.3297",
  "inbound-db-properties-service-client": "static-1.3934",
  "superstore": "static-1.4877",
  "feedback-loader": "static-1.29526",
  "ai-components-ui-library": "static-1.9258",
  "ui-addon-video-player": "static-1.8822",
  "ui-coaching-tips": "static-1.28891",
  "ContentUtils": "static-1.68715",
  "fix-webm-duration": "static-1.24",
  "notification-sounds": "static-1.4544",
  "sassPrefix": "static-1.158",
  "react-dnd-compat": "static-1.4733",
  "react-immutable-proptypes": "static-2.8",
  "react-immutable-render-mixin": "static-1.9",
  "breeze-engine-lib": "static-1.1133",
  "copilot-toolkit": "static-1.11440",
  "avatar-components": "static-1.2616",
  "navigation-messaging": "static-1.7633",
  "redux-thunk": "static-2.43",
  "reference-resolvers": "static-1.8293",
  "reselect": "static-2.16",
  "commerce-products-lib": "static-1.10007",
  "crm-message-bus": "static-1.43297",
  "growth-data-modal": "static-1.5625",
  "hubspot-apollo-client": "static-1.4996",
  "onboarding-tours-client": "static-1.5045",
  "calling-global-api": "static-1.64921",
  "calling-internal-common": "static-1.31428",
  "calling-lifecycle-internal": "static-1.66303",
  "calling-lifecycle-messages": "static-1.58597",
  "conditional-properties-service-client": "static-1.3885",
  "crm-links": "static-1.6426",
  "crm-pipelines-api-client-types": "static-1.4224",
  "customer-data-objects-ui-components": "static-1.13147",
  "customer-data-properties-shared-msw-handlers": "static-1.9587",
  "customer-data-property-utils": "static-1.8213",
  "external-options-client-types": "static-1.4214",
  "framework-data-schema-resolvers": "static-1.7012",
  "google-libphonenumber": "static-1.39",
  "hs-resources": "static-1.293",
  "inbound-db-meta-service-client": "static-1.3674",
  "inbounddb-objects-service-types": "static-1.4305",
  "meetings-icalendar-utils-lib": "static-1.751",
  "multi-currency-client-types": "static-1.3778",
  "object-builder-ui-client": "static-1.49157",
  "pipeline-validation-client-types": "static-1.4053",
  "property-value-citations": "static-1.2591",
  "pulse": "static-1.723",
  "smart-property-lib": "static-1.7849",
  "tiered-pricing": "static-1.1533",
  "ui-addon-form-validation": "static-1.11108",
  "zustand": "static-1.74",
  "growth-onboarding-confetti": "static-1.3183",
  "growth-onboarding-next-action-utils": "static-1.2261",
  "navigation-components": "static-1.18306",
  "onboarding-tours-utils": "static-1.897",
  "ui-shepherd-tracker": "static-1.7750",
  "ui-universal-auth": "static-1.9121",
  "batch-promise": "static-1.1661",
  "getting-started-shared-tasks-store": "static-1.17862",
  "hubspotter-http-shared-msw-handlers": "static-1.10258",
  "usage-tracker-session-replay": "static-1.5153",
  "base-ui": "static-1.14",
  "react-day-picker": "static-1.4",
  "trellis-theming": "static-1.1059",
  "tanstack-virtual": "static-1.31",
  "audio-components": "static-1.6104",
  "FileManagerCore": "static-1.39459",
  "FileManagerImages": "static-1.37111",
  "video-components": "static-1.13667",
  "foundations-components-legacy": "static-1.1199",
  "purchase-motions-api": "static-1.6101",
  "signup-constants": "static-1.19139",
  "signup-ui-url-generator": "static-2.8175",
  "usage-tracker-public": "static-1.7278",
  "reactive-lib": "static-1.844",
  "simple-logging-lib": "static-1.3167",
  "chatspot-core": "static-1.21866",
  "growth-onboarding-feedback-components": "static-1.6696",
  "cms-field-types": "static-1.4933",
  "content-icons-ui": "static-1.2260",
  "integrations-lib": "static-1.16535",
  "underscore": "static-1.8",
  "breeze-engine-core": "static-1.411",
  "ably": "static-2.2",
  "highlight.js": "static-1.80",
  "markdown-it": "static-1.6",
  "commerce-permissions": "static-1.894",
  "customer-data-tracking": "static-1.7005",
  "products-iframe-lib": "static-1.8261",
  "products-ui-components-shared-msw-handlers": "static-1.10642",
  "restore-request-side-panel-lib": "static-1.1174",
  "onboarding-data-sync-lib": "static-1.2173",
  "hubspot-apollo-cache": "static-1.455",
  "calling-error-reporting": "static-1.31435",
  "shared-worker-versioning": "static-1.11153",
  "calling-usage-tracker": "static-1.6661",
  "voice-sms-access-library": "static-1.1450",
  "conversations-skeleton-state": "static-1.7365",
  "location-customization-utils-lib": "static-1.9604",
  "fdsr-migration-layer": "static-1.131",
  "framework-builder-read-service-client": "static-1.4091",
  "framework-data-schema-quick-fetch": "static-1.6917",
  "persist-promise": "static-1.3818",
  "event-emitter": "static-1.1067",
  "bend-plugin-pulse": "static-1.226",
  "fast-json-patch": "static-1.64",
  "data-agent-kit": "static-1.398",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.10343",
  "fsm": "static-1.3847",
  "policy-lib": "static-1.6903",
  "react-tinymce": "static-1.55561",
  "reference-resolvers-lite-shared-msw-handlers": "static-1.10406",
  "tinymce": "static-5.11",
  "tinymce-config": "static-2.54687",
  "tinymce-plugins": "static-1.57801",
  "tinymce-themes": "static-1.56657",
  "growth-onboarding-next-action-components": "static-1.2289",
  "user-context-client": "static-1.4698",
  "nest": "static-1.351",
  "unified-auth-core-lib": "static-1.917",
  "amplitude-session-replay-browser": "static-1.60",
  "cropperjs": "static-1.10",
  "html-to-image": "static-1.55",
  "redux-toolkit": "static-1.7",
  "urlinator": "static-1.4654",
  "video-embed": "static-1.36157",
  "social-insights-client-types": "static-1.22353",
  "flux-actions": "static-1.346",
  "integrations-error-boundary-lib": "static-1.13950",
  "integrations-tracking-lib": "static-1.5724",
  "native-integrations-shared-strings": "static-1.7900",
  "redux-observable": "static-1.11",
  "ReduxMessenger": "static-2.10480",
  "rxjs": "static-5.10",
  "unified-auth": "static-1.635",
  "sales-views-client-types": "static-1.4375",
  "InboxConnectUtils": "static-4.15126",
  "meetings-connect-utils-lib": "static-1.7723",
  "calling-orchestration-schema": "static-1.36227",
  "crm-record-cards-service-types": "static-1.3673",
  "highcharts": "static-8.105",
  "trellis-story-utils": "static-1.4629",
  "storybook-react": "static-1.34",
  "hub-http-contrib": "static-1.3161",
  "tinymce-data": "static-1.40772",
  "ui-addon-sales-email": "static-1.5328",
  "codemirror": "static-5.96",
  "layout-dnd-components": "static-1.12682",
  "layout-dnd-utils": "static-1.11657",
  "react-codemirror": "static-1.10745",
  "ui-brand-identity-lib": "static-1.15714",
  "NamespacedHubStyle": "static-2.9141",
  "outpost": "static-1.4287",
  "universal-page-editor-lib": "static-1.3133",
  "adobe-sign-auth-lib": "static-1.25",
  "ads-unified-auth-lib": "static-1.396",
  "google-sheets-integration-lib": "static-1.590",
  "microsoft-drive-integration-lib": "static-1.728",
  "surveymonkey-integration-lib": "static-1.45",
  "slack-ui-library": "static-1.10514",
  "diff-match-patch": "static-1.7",
  "ContentData": "static-1.68790",
  "layout-data-lib": "static-1.9982",
  "browser-eslint": "static-2.57",
  "advanced-menus-core": "static-1.15331",
  "advanced-menus-lib": "static-1.12242",
  "ExportDialog": "static-6.10498",
  "ui-memberships-settings-lib": "static-1.34363",
  "seamless-immutable": "static-7.6",
  "simple-menus-core": "static-1.15330",
  "simple-menus-lib": "static-1.16847"
},
  depPathPrefixes: {
  "customer-portal-app": "/customer-portal-app/static-1.2691",
  "apollo-dlb": "/apollo-dlb/static-3.86",
  "client-types": "/client-types/static-1.481",
  "data-fetching-client": "/data-fetching-client/static-1.9780",
  "emoji-mart": "/emoji-mart/static-3.4",
  "enviro": "/enviro/static-4.455",
  "growth-payments-core": "/growth-payments-core/static-1.25729",
  "head-dlb": "/head-dlb/static-1.5007",
  "hs-lodash": "/hs-lodash/static-4.45",
  "hs-promise-utils": "/hs-promise-utils/static-1.5711",
  "hs-test-utils": "/hs-test-utils/static-1.8138",
  "hub-http": "/hub-http/static-1.6341",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.10260",
  "hubspot-dlb": "/hubspot-dlb/static-2.1854",
  "hubspot-prosemirror": "/hubspot-prosemirror/static-1.18583",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4132",
  "HubStyleTokens": "/HubStyleTokens/static-2.11590",
  "I18n": "/I18n/static-7.1639",
  "immutable": "/immutable/static-2.79",
  "jasmine-runner": "/jasmine-runner/static-1.6576",
  "payment-link-components": "/payment-link-components/static-1.23831",
  "prosemirror": "/prosemirror/static-1.13",
  "quartz": "/quartz/static-1.7183",
  "quartz-core": "/quartz-core/static-1.6402",
  "quartz-i18n": "/quartz-i18n/static-1.858",
  "react": "/react/static-7.187",
  "react-colorpicker": "/react-colorpicker/static-2.10325",
  "react-dlb": "/react-dlb/static-1.81",
  "react-utils": "/react-utils/static-2.5429",
  "rich-text-lib": "/rich-text-lib/static-1.20043",
  "transmute": "/transmute/static-2.85",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.18157",
  "ui-components-test-utils": "/ui-components-test-utils/static-1.5727",
  "UIComponents": "/UIComponents/static-3.8536",
  "foundations-assets": "/foundations-assets/static-1.4991",
  "foundations-components": "/foundations-components/static-1.8174",
  "foundations-theming": "/foundations-theming/static-1.4551",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2267",
  "framer-motion": "/framer-motion/static-1.73",
  "metrics-js": "/metrics-js/static-1.9637",
  "PortalIdParser": "/PortalIdParser/static-2.404",
  "portals-platform-lib": "/portals-platform-lib/static-1.1175",
  "quartz-config": "/quartz-config/static-1.961",
  "quartz-routing": "/quartz-routing/static-1.613",
  "quick-fetch": "/quick-fetch/static-1.4005",
  "react-dnd": "/react-dnd/static-5.6",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-5.6",
  "react-dom": "/react-dom/static-7.85",
  "react-rhumb": "/react-rhumb/static-1.16802",
  "rpc-client-utils": "/rpc-client-utils/static-1.4775",
  "sanitize-text": "/sanitize-text/static-1.8263",
  "styled-components": "/styled-components/static-2.89",
  "tanstack-table": "/tanstack-table/static-1.56",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.4877",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.9655",
  "usage-tracker": "/usage-tracker/static-1.7467",
  "usage-tracker-anonymous": "/usage-tracker-anonymous/static-1.5884",
  "usage-tracker-core": "/usage-tracker-core/static-1.7317",
  "video-components-external": "/video-components-external/static-1.11665",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.84",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5587",
  "raven": "/raven/static-3.5925",
  "raven-hubspot": "/raven-hubspot/static-1.6232",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "react-redux": "/react-redux/static-7.71",
  "redux": "/redux/static-4.16",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3485",
  "moment": "/moment/static-3.26",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3460",
  "quartz-webpack": "/quartz-webpack/static-1.3407",
  "bend-plugin-quartz-routing": "/bend-plugin-quartz-routing/static-1.261",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "graphql": "/graphql/static-1.83",
  "customer-data-objects": "/customer-data-objects/static-1.7797",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.8045",
  "laboratory-lib": "/laboratory-lib/static-3.7271",
  "onboarding-scopes": "/onboarding-scopes/static-1.6578",
  "seat-types-lib": "/seat-types-lib/static-1.280",
  "ui-addon-opt": "/ui-addon-opt/static-4.8479",
  "HeadJS": "/HeadJS/static-2.771",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3249",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.153",
  "hs-locale-management": "/hs-locale-management/static-1.169",
  "ts-schema": "/ts-schema/static-1.4169",
  "webpack-env": "/webpack-env/static-1.54",
  "content-assistance-lib": "/content-assistance-lib/static-1.7948",
  "content-media-capture": "/content-media-capture/static-1.4876",
  "cssUtils": "/cssUtils/static-1.826",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.9943",
  "file-manager-components": "/file-manager-components/static-1.23960",
  "HubStyle": "/HubStyle/static-2.11897",
  "knowledge-content-types": "/knowledge-content-types/static-1.8559",
  "PatternValidationJS": "/PatternValidationJS/static-1.437",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "StyleGuideUI": "/StyleGuideUI/static-3.489",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.10005",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11267",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.9185",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.10369",
  "video-data-lib": "/video-data-lib/static-1.35323",
  "i18n-data": "/i18n-data/static-1.223",
  "moment-timezone": "/moment-timezone/static-5.84",
  "jasmine": "/jasmine/static-4.4444",
  "commerce-tours-lib": "/commerce-tours-lib/static-1.6323",
  "customer-data-properties": "/customer-data-properties/static-1.51977",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.18744",
  "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.5199",
  "onboarding-tours": "/onboarding-tours/static-1.16831",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.8215",
  "sales-checkout-service-client": "/sales-checkout-service-client/static-1.3711",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.9185",
  "user-context": "/user-context/static-1.5227",
  "dispatcher": "/dispatcher/static-1.138",
  "general-store": "/general-store/static-6.20",
  "hub-http-janus": "/hub-http-janus/static-1.846",
  "hubspotter-http": "/hubspotter-http/static-1.4738",
  "icons": "/icons/static-2.654",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.545",
  "module-federation": "/module-federation/static-1.27",
  "quartz-auth": "/quartz-auth/static-1.858",
  "quartz-head": "/quartz-head/static-1.848",
  "quartz-test": "/quartz-test/static-1.858",
  "quartz-tracking": "/quartz-tracking/static-1.562",
  "trellis-components": "/trellis-components/static-1.2217",
  "ui-fonts": "/ui-fonts/static-1.852",
  "usage-tracker-container": "/usage-tracker-container/static-1.7457",
  "csstype": "/csstype/static-1.50",
  "hs-story-utils": "/hs-story-utils/static-1.9541",
  "data-token-picker": "/data-token-picker/static-1.16625",
  "FileManagerLib": "/FileManagerLib/static-1.39600",
  "property-translator": "/property-translator/static-1.5515",
  "atom": "/atom/static-1.5193",
  "merchandise-lib": "/merchandise-lib/static-1.266",
  "purchase-motions-components": "/purchase-motions-components/static-1.6098",
  "salesImages": "/salesImages/static-1.527",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.182",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.5657",
  "react-create-root-preference": "/react-create-root-preference/static-1.37",
  "react-select-plus": "/react-select-plus/static-1.106",
  "react-virtualized": "/react-virtualized/static-2.100",
  "ui-images": "/ui-images/static-2.1184",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.4444",
  "floating-ui": "/floating-ui/static-1.58",
  "react-aria": "/react-aria/static-1.67",
  "trellis-assets": "/trellis-assets/static-1.2198",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.3034",
  "foundations-theming-base": "/foundations-theming-base/static-1.3536",
  "stylex": "/stylex/static-1.35",
  "interframe": "/interframe/static-3.4878",
  "js-cookie": "/js-cookie/static-1.18",
  "usage-tracker-multi": "/usage-tracker-multi/static-1.5881",
  "web-vitals": "/web-vitals/static-1.7",
  "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.185",
  "chirp-fetch": "/chirp-fetch/static-1.2006",
  "autolinker": "/autolinker/static-3.11",
  "sanitize": "/sanitize/static-1.4594",
  "react-flip-move": "/react-flip-move/static-1.72",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4769",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.12680",
  "content-media-compositions": "/content-media-compositions/static-2.16687",
  "idb-keyval": "/idb-keyval/static-1.45",
  "immer": "/immer/static-1.33",
  "immerable": "/immerable/static-1.4268",
  "magpie-lib": "/magpie-lib/static-1.5629",
  "magpie-types": "/magpie-types/static-1.5089",
  "media-bridge-lib": "/media-bridge-lib/static-1.19138",
  "bender-build-tools": "/bender-build-tools/static-1.3297",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.3934",
  "superstore": "/superstore/static-1.4877",
  "feedback-loader": "/feedback-loader/static-1.29526",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.9258",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.8822",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.28891",
  "ContentUtils": "/ContentUtils/static-1.68715",
  "fix-webm-duration": "/fix-webm-duration/static-1.24",
  "notification-sounds": "/notification-sounds/static-1.4544",
  "sassPrefix": "/sassPrefix/static-1.158",
  "react-dnd-compat": "/react-dnd-compat/static-1.4733",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "breeze-engine-lib": "/breeze-engine-lib/static-1.1133",
  "copilot-toolkit": "/copilot-toolkit/static-1.11440",
  "avatar-components": "/avatar-components/static-1.2616",
  "navigation-messaging": "/navigation-messaging/static-1.7633",
  "redux-thunk": "/redux-thunk/static-2.43",
  "reference-resolvers": "/reference-resolvers/static-1.8293",
  "reselect": "/reselect/static-2.16",
  "commerce-products-lib": "/commerce-products-lib/static-1.10007",
  "crm-message-bus": "/crm-message-bus/static-1.43297",
  "growth-data-modal": "/growth-data-modal/static-1.5625",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.4996",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.5045",
  "calling-global-api": "/calling-global-api/static-1.64921",
  "calling-internal-common": "/calling-internal-common/static-1.31428",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.66303",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.58597",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3885",
  "crm-links": "/crm-links/static-1.6426",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4224",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.13147",
  "customer-data-properties-shared-msw-handlers": "/customer-data-properties-shared-msw-handlers/static-1.9587",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.8213",
  "external-options-client-types": "/external-options-client-types/static-1.4214",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.7012",
  "google-libphonenumber": "/google-libphonenumber/static-1.39",
  "hs-resources": "/hs-resources/static-1.293",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3674",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4305",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.751",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3778",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.49157",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.4053",
  "property-value-citations": "/property-value-citations/static-1.2591",
  "pulse": "/pulse/static-1.723",
  "smart-property-lib": "/smart-property-lib/static-1.7849",
  "tiered-pricing": "/tiered-pricing/static-1.1533",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.11108",
  "zustand": "/zustand/static-1.74",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.3183",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.2261",
  "navigation-components": "/navigation-components/static-1.18306",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.897",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.7750",
  "ui-universal-auth": "/ui-universal-auth/static-1.9121",
  "batch-promise": "/batch-promise/static-1.1661",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.17862",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.10258",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.5153",
  "base-ui": "/base-ui/static-1.14",
  "react-day-picker": "/react-day-picker/static-1.4",
  "trellis-theming": "/trellis-theming/static-1.1059",
  "tanstack-virtual": "/tanstack-virtual/static-1.31",
  "audio-components": "/audio-components/static-1.6104",
  "FileManagerCore": "/FileManagerCore/static-1.39459",
  "FileManagerImages": "/FileManagerImages/static-1.37111",
  "video-components": "/video-components/static-1.13667",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.1199",
  "purchase-motions-api": "/purchase-motions-api/static-1.6101",
  "signup-constants": "/signup-constants/static-1.19139",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.8175",
  "usage-tracker-public": "/usage-tracker-public/static-1.7278",
  "reactive-lib": "/reactive-lib/static-1.844",
  "simple-logging-lib": "/simple-logging-lib/static-1.3167",
  "chatspot-core": "/chatspot-core/static-1.21866",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6696",
  "cms-field-types": "/cms-field-types/static-1.4933",
  "content-icons-ui": "/content-icons-ui/static-1.2260",
  "integrations-lib": "/integrations-lib/static-1.16535",
  "underscore": "/underscore/static-1.8",
  "breeze-engine-core": "/breeze-engine-core/static-1.411",
  "ably": "/ably/static-2.2",
  "highlight.js": "/highlight.js/static-1.80",
  "markdown-it": "/markdown-it/static-1.6",
  "commerce-permissions": "/commerce-permissions/static-1.894",
  "customer-data-tracking": "/customer-data-tracking/static-1.7005",
  "products-iframe-lib": "/products-iframe-lib/static-1.8261",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.10642",
  "restore-request-side-panel-lib": "/restore-request-side-panel-lib/static-1.1174",
  "onboarding-data-sync-lib": "/onboarding-data-sync-lib/static-1.2173",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.455",
  "calling-error-reporting": "/calling-error-reporting/static-1.31435",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.11153",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.6661",
  "voice-sms-access-library": "/voice-sms-access-library/static-1.1450",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7365",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.9604",
  "fdsr-migration-layer": "/fdsr-migration-layer/static-1.131",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.4091",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.6917",
  "persist-promise": "/persist-promise/static-1.3818",
  "event-emitter": "/event-emitter/static-1.1067",
  "bend-plugin-pulse": "/bend-plugin-pulse/static-1.226",
  "fast-json-patch": "/fast-json-patch/static-1.64",
  "data-agent-kit": "/data-agent-kit/static-1.398",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.10343",
  "fsm": "/fsm/static-1.3847",
  "policy-lib": "/policy-lib/static-1.6903",
  "react-tinymce": "/react-tinymce/static-1.55561",
  "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.10406",
  "tinymce": "/tinymce/static-5.11",
  "tinymce-config": "/tinymce-config/static-2.54687",
  "tinymce-plugins": "/tinymce-plugins/static-1.57801",
  "tinymce-themes": "/tinymce-themes/static-1.56657",
  "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.2289",
  "user-context-client": "/user-context-client/static-1.4698",
  "nest": "/nest/static-1.351",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.917",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.60",
  "cropperjs": "/cropperjs/static-1.10",
  "html-to-image": "/html-to-image/static-1.55",
  "redux-toolkit": "/redux-toolkit/static-1.7",
  "urlinator": "/urlinator/static-1.4654",
  "video-embed": "/video-embed/static-1.36157",
  "social-insights-client-types": "/social-insights-client-types/static-1.22353",
  "flux-actions": "/flux-actions/static-1.346",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.13950",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5724",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.7900",
  "redux-observable": "/redux-observable/static-1.11",
  "ReduxMessenger": "/ReduxMessenger/static-2.10480",
  "rxjs": "/rxjs/static-5.10",
  "unified-auth": "/unified-auth/static-1.635",
  "sales-views-client-types": "/sales-views-client-types/static-1.4375",
  "InboxConnectUtils": "/InboxConnectUtils/static-4.15126",
  "meetings-connect-utils-lib": "/meetings-connect-utils-lib/static-1.7723",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.36227",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3673",
  "highcharts": "/highcharts/static-8.105",
  "trellis-story-utils": "/trellis-story-utils/static-1.4629",
  "storybook-react": "/storybook-react/static-1.34",
  "hub-http-contrib": "/hub-http-contrib/static-1.3161",
  "tinymce-data": "/tinymce-data/static-1.40772",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5328",
  "codemirror": "/codemirror/static-5.96",
  "layout-dnd-components": "/layout-dnd-components/static-1.12682",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.11657",
  "react-codemirror": "/react-codemirror/static-1.10745",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.15714",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.9141",
  "outpost": "/outpost/static-1.4287",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.3133",
  "adobe-sign-auth-lib": "/adobe-sign-auth-lib/static-1.25",
  "ads-unified-auth-lib": "/ads-unified-auth-lib/static-1.396",
  "google-sheets-integration-lib": "/google-sheets-integration-lib/static-1.590",
  "microsoft-drive-integration-lib": "/microsoft-drive-integration-lib/static-1.728",
  "surveymonkey-integration-lib": "/surveymonkey-integration-lib/static-1.45",
  "slack-ui-library": "/slack-ui-library/static-1.10514",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "ContentData": "/ContentData/static-1.68790",
  "layout-data-lib": "/layout-data-lib/static-1.9982",
  "browser-eslint": "/browser-eslint/static-2.57",
  "advanced-menus-core": "/advanced-menus-core/static-1.15331",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.12242",
  "ExportDialog": "/ExportDialog/static-6.10498",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.34363",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "simple-menus-core": "/simple-menus-core/static-1.15330",
  "simple-menus-lib": "/simple-menus-lib/static-1.16847"
}
};
